/** @format */

import { useContext } from 'react';
import AuthContext from 'src/contexts/KeyCloakContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
